// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_0CT","inner":"Footer_inner__3bvHn"};